import { SwitchGroup } from '../..'
import { ELSE_HANDLE_ID } from '../../switch.constants'

export const createSwitchHandleMapping = (
  groups: SwitchGroup[]
): Record<string, number> => {
  const groupMapping = groups.reduce(
    (acc, curr, index) => ({ ...acc, [curr.id]: index }),
    {} as Record<string, number>
  )

  return { ...groupMapping, [ELSE_HANDLE_ID]: groups.length }
}
